<template>
  <div class="about">
    <audio
      id="audio_with_controls"
      controls
      src="../assets/test Edit 1 Export 7.wav"
      type="audio/wav"
    >
      Ihr Browser kann dieses Tondokument nicht wiedergeben.
      <br />Sie können es unter
      <a href="../assets/test Edit 1 Export 7.wav">diesem Link</a>
      abrufen.
    </audio>
    <audio
      id="audio_with_controls"
      controls
      src="../assets/mood Edit 1 Export 1.wav"
      type="audio/wav"
    >
      Ihr Browser kann dieses Tondokument nicht wiedergeben.
      <br />Sie können es unter
      <a href="../assets/mood Edit 1 Export 1.wav">diesem Link</a>
      abrufen.
    </audio>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
#avatar {
  position: absolute;
  height: 300px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  width: 300px;
  top: 50%;
  left: 30%;
  transform: translate(-50%, -50%);
}
#aboutMe {
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  font-size: 14pt;
}
</style>
